var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "course-schedules-list" }, [
    _c("div", { staticClass: "table-responsive" }, [
      _c(
        "table",
        { staticClass: "table table-reset" },
        [
          _vm._m(0),
          _vm._v(" "),
          _vm._l(_vm.courseSchedulesGrouped, function (day) {
            return _c(
              "tbody",
              [
                _c("tr", [
                  _c("th", { attrs: { colspan: "7" } }, [
                    _vm._v(_vm._s(_vm.dateFormat(day.date, "dddd, MMMM D"))),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm.allow.create
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-success",
                            on: {
                              click: function ($event) {
                                return _vm.addSchedule(day.date, 6)
                              },
                            },
                          },
                          [_vm._v("add class to schedule")]
                        )
                      : _vm._e(),
                  ]),
                ]),
                _vm._v(" "),
                _vm._l(day.course_schedules, function (courseSchedule) {
                  return _c(
                    "tr",
                    {
                      staticClass: "course_schedule",
                      class: {
                        selected:
                          courseSchedule.id === _vm.selectedCourseSchedule.id,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.showScheduleDetails(courseSchedule)
                        },
                      },
                    },
                    [
                      _c("td", [_vm._v(_vm._s(courseSchedule.id))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(courseSchedule.path.name))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(courseSchedule.course.name))]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            courseSchedule.location
                              ? courseSchedule.location.name
                              : "no"
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            courseSchedule.trainer
                              ? courseSchedule.trainer.name
                              : "no"
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(_vm.dateFormat(courseSchedule.from, "hh:mm a"))
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(_vm.dateFormat(courseSchedule.till, "hh:mm a"))
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        courseSchedule.guest_ids &&
                        Array.isArray(courseSchedule.guest_ids)
                          ? _c("span", [
                              _vm._v(_vm._s(courseSchedule.guest_ids.length)),
                            ])
                          : _vm._e(),
                      ]),
                    ]
                  )
                }),
              ],
              2
            )
          }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("path")]),
        _vm._v(" "),
        _c("th", [_vm._v("class")]),
        _vm._v(" "),
        _c("th", [_vm._v("location")]),
        _vm._v(" "),
        _c("th", [_vm._v("trainer")]),
        _vm._v(" "),
        _c("th", [_vm._v("from")]),
        _vm._v(" "),
        _c("th", [_vm._v("until")]),
        _vm._v(" "),
        _c("th", [_vm._v("guests")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }